<template>
  <div class="personalData_page" style="width:1400px;margin: auto;">
    <div style="width:100%;height:68px;background: #E4E6EF;display: flex;align-content: center;">
      <router-link to="/spreader/home" style="margin: auto 0 auto 20px;" exact>
        <img width="32px" height="32px" src="../../assets/spreader/return.png" />
      </router-link>
      <p
        style="font-size: 20px;font-family: Microsoft YaHei;font-weight: bold;color: #292929;margin: 0 0 0 20px;padding: 0;line-height: 68px;">
        返回首页</p>
    </div>
    <div style="width:100%;height:1200px;background: #FFFFFF;">
      <div style="display: flex;align-content: center;padding: 30px 0 0 72px;">
        <div style="width:4px;height:18px;background: #347BFF;border-radius: 2px;margin: auto 0;"></div>
        <span
          style="font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #292929;margin-left: 12px;">个人银行卡提现</span>
      </div>
      <div style="margin: 10px 0 0 90px;font-size: 14px;
      font-family: Microsoft YaHei;font-weight: 400;color: #999999;">
        填写的信息须与证件信息一致，才能确保正常提现入账
      </div>
      <p style="font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #292929;margin: 34px 0 0 88px;">个人信息</p>
      <div style="width: 1312px;
        height: 1px;
        background: #ECECEC;margin: 15px 0 0 88px;"></div>
      <div class="personalData_page1" style="display:flex;justify-content: space-between;
       margin: 20px 0 0 110px;align-items: center;width: 405px;">
        <span style="display:block;width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;">昵称</span>
        <el-input type="text" v-model="nickname" style="width:280px" placeholder="请输入昵称"></el-input>
      </div>
      <div style="display:flex;margin: 20px 0 0 110px;">
        <span style="width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;padding-right: 15px;">头像</span>
        <el-upload class="avatar-uploader" :action="headerPicUploadUrl" name="test" :show-file-list="false"
          :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="headPicUrl" :src="headPicUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div v-if="headPicUrl == undefined || headPicUrl == ''" class="el-upload__text" style="font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #B8BABB;margin-top: 17px;">上传图片</div>
        </el-upload>
        <span style="width: 242px;
          height: 33px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 20px;margin-left: 12px;padding-top: 5px;">
          请上传清晰图片作为头像，尺寸不小于80*80 上传格式：jpg、jpeg、png，大小不超过2M
        </span>
      </div>
      <p style="font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #292929;margin: 34px 0 0 88px;">身份证明</p>
      <div style="width: 1312px;
        height: 1px;
        background: #ECECEC;margin: 15px 0 0 88px;"></div>
      <div class="personalData_page1" style="display:flex;justify-content: space-between;
       margin: 20px 0 0 110px;align-items: center;width: 405px;">
        <span style="display:block;width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;"><span style="width: 8px;height: 8px;color: #E74A4A;">*</span>真实姓名</span>
        <el-input type="text" v-model="idCardName" style="width:280px" placeholder="真实姓名，需与身份证一致"></el-input>
      </div>
      <div class="personalData_page1" style="display:flex;justify-content: space-between;
       margin: 20px 0 0 110px;align-items: center;width: 405px;">
        <span style="display:block;width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;"><span style="width: 8px;height: 8px;color: #E74A4A;">*</span>手机号</span>
        <el-input type="text" v-model="tel" style="width:280px" placeholder="输入真实手机号"></el-input>
      </div>
      <div class="personalData_page1" style="display:flex;justify-content: space-between;
       margin: 20px 0 0 110px;align-items: center;width: 405px;">
        <span style="display:block;width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;"><span style="width: 8px;height: 8px;color: #E74A4A;">*</span>身份证号</span>
        <el-input type="text" v-model="idCardNum" style="width:280px" placeholder="请输入身份证号"></el-input>
      </div>
      <div style="display:flex;margin: 20px 0 0 110px;">
        <span style="width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;padding-right: 15px;"><span
            style="width: 8px;height: 8px;color: #E74A4A;">*</span>证件照片</span>
        <div>
          <div style="display:flex">
            <el-upload class="avatar-uploader2" :action="headerPicUploadUrl" name="test" :show-file-list="false"
              :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload2">
              <img v-if="idCardFrontImage" :src="idCardFrontImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div v-if="idCardFrontImage == undefined || idCardFrontImage == ''" class="el-upload__text" style="font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #B8BABB;margin-top: 17px;">点击上传正面照片</div>
            </el-upload>
            <el-upload class="avatar-uploader2" :action="headerPicUploadUrl" name="test" :show-file-list="false"
              :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
              <img v-if="idCardBackImage" :src="idCardBackImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div v-if="idCardBackImage == undefined || idCardBackImage == ''" class="el-upload__text" style="font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #B8BABB;margin-top: 17px;">点击上传反面照片</div>
            </el-upload>
          </div>
          <span style="margin-left:10px;margin-top:12px;display:block;width: 242px;
            height: 34px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 20px;">请上传清晰真实的本人正反证件照片<br>上传格式：jpg、jpeg、png，大小不超过5M</span>
        </div>
        <div style="display:flex;margin-left:30px;">
          <span style="width: 48px;
            height: 11px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #347BFF;cursor: pointer;" @click="idCardViewSet()">查看样例</span>
          <img v-if="idCardFlag == true" width="192px" height="108px" src="../../assets/spreader/sfzz.jpg"
            style="margin-left:16px;" />
          <img v-if="idCardFlag == true" width="192px" height="108px" src="../../assets/spreader/sfzf.jpg"
            style="margin-left:12px;" />
        </div>
      </div>
      <div class="personalData_page1" style="display:flex;justify-content: space-between;
       margin: 20px 0 0 110px;align-items: center;width: 405px;">
        <span style="display:block;width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;"><span style="width: 8px;height: 8px;color: #E74A4A;">*</span>银行卡号</span>
        <el-input type="text" v-model="bankCardNum" style="width:280px" placeholder="真实有效，与上传一致"></el-input>
      </div>
      <div class="personalData_page1" style="display:flex;justify-content: space-between;
       margin: 20px 0 0 110px;align-items: center;width: 405px;">
        <span style="display:block;width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;"><span style="width: 8px;height: 8px;color: #E74A4A;">*</span>银行开户行</span>
        <el-input type="text" v-model="bankCardName" style="width:280px" placeholder="真实有效，与上传一致"></el-input>
      </div>
      <div style="display:flex;margin: 20px 0 0 110px;">
        <span style="width:100px;font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #292929;text-align: right;padding-right: 15px;"><span
            style="width: 8px;height: 8px;color: #E74A4A;">*</span>银行卡</span>
        <div>
          <div style="display:flex">
            <el-upload class="avatar-uploader2" :action="headerPicUploadUrl" name="test" :show-file-list="false"
              :on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload2">
              <img v-if="bankCardFrontImage" :src="bankCardFrontImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div v-if="bankCardFrontImage == undefined || bankCardFrontImage == ''" class="el-upload__text" style="font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #B8BABB;margin-top: 17px;">点击上传正面照片</div>
            </el-upload>
            <el-upload class="avatar-uploader2" :action="headerPicUploadUrl" name="test" :show-file-list="false"
              :on-success="handleAvatarSuccess4" :before-upload="beforeAvatarUpload2">
              <img v-if="bankCardBackImage" :src="bankCardBackImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div v-if="bankCardBackImage == undefined || bankCardBackImage == ''" class="el-upload__text" style="font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #B8BABB;margin-top: 17px;">点击上传反面照片</div>
            </el-upload>
          </div>
          <span style="margin-left:10px;margin-top:12px;display:block;width: 276px;
            height: 34px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 20px;">请上传清晰真实的与填写一致的本人银行卡正反照片<br>上传格式：jpg、jpeg、png，大小不超过5M</span>
        </div>
        <div style="display:flex;margin-left:30px;">
          <span style="width: 48px;
            height: 11px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #347BFF;cursor: pointer;" @click="bankCardViewSet()">查看样例</span>
          <img v-if="bankCardFlag == true" width="192px" height="108px" src="../../assets/spreader/bankz.jpg"
            style="margin-left:16px;" />
          <img v-if="bankCardFlag == true" width="192px" height="108px" src="../../assets/spreader/bankf.jpg"
            style="margin-left:12px;" />
        </div>
      </div>
      <button style="width: 128px;
        height: 40px;
        background: #347BFF;
        border-radius: 4px;border:0;font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;margin: 64px 0 0 236px;cursor: pointer;" @click="submit()">提交</button>
    </div>
  </div>
</template>
<script>
import { getHeadPic } from '@/utils/spreaderUtils'
import { updateInfo, getinfo } from '@/api/spreader/user';
import { getId } from '../../utils/auth';

export default {
  name: "personalData_page",
  props: {
    userInfo: {
      nickname: '',
      headPic: '',
      code: '',
      getBalance: '',
      gotBalance: '',
      inviterNum: '',
      idCardName: '',
      tel: '',
      idCardNum: '',
      bankCardName: '',
      bankCardNum: '',
    },
    headPicUrl: ''
  },
  components: {
  },
  created() {
  },
  destroyed: function () {
  },
  mounted: function () {
    //文件上传地址
    this.headerPicUploadUrl = this.$sip + '/file/upload';

    this.getInfo();
  },
  methods: {
    getInfo() {
      return new Promise((resolve, reject) => {
        getinfo().then(res => {
          if (res.status == 200) {
            this.idCardFrontImage = res.data.idCardFront == undefined ? '' : this.$sip + res.data.idCardFront;
            this.idCardBackImage = res.data.idCardBack == undefined ? '' : this.$sip + res.data.idCardBack;
            this.bankCardFrontImage = res.data.bankCardFront == undefined ? '' : this.$sip + res.data.bankCardFront;
            this.bankCardBackImage = res.data.bankCardBack == undefined ? '' : this.$sip + res.data.bankCardBack;

            this.nickname = res.data.nickname == undefined ? "" : res.data.nickname;
            this.tel = res.data.tel == undefined ? "" : res.data.tel;
            this.headPic = res.data.headPic == undefined ? "" : res.data.headPic;
            this.idCardName = res.data.idCardName == undefined ? "" : res.data.idCardName;
            this.idCardNum = res.data.idCardNum == undefined ? "" : res.data.idCardNum;
            this.idCardBack = res.data.idCardBack == undefined ? "" : res.data.idCardBack;
            this.idCardFront = res.data.idCardFront == undefined ? "" : res.data.idCardFront;
            this.bankCardName = res.data.bankCardName == undefined ? "" : res.data.bankCardName;
            this.bankCardNum = res.data.bankCardNum == undefined ? "" : res.data.bankCardNum;
            this.bankCardBack = res.data.bankCardBack == undefined ? "" : res.data.bankCardBack;
            this.bankCardFront = res.data.bankCardFront == undefined ? "" : res.data.bankCardFront;

            this.headPicUrl = getHeadPic(this.$sip, res.data.headPic);
          } else {
            this.$message(res.message);
          }
        })
      })
    },
    submit() {
      const loading = this.$loading({
        lock: true,
        text: '正在提交!',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = {
        id: getId(),
        nickname: this.nickname,
        tel: this.tel,
        headPic: this.headPic,
        idCardName: this.idCardName,
        idCardNum: this.idCardNum,
        idCardBack: this.idCardBack,
        idCardFront: this.idCardFront,
        bankCardNum: this.bankCardNum,
        bankCardName: this.bankCardName,
        bankCardFront: this.bankCardFront,
        bankCardBack: this.bankCardBack,
      }
      return new Promise((resolve, reject) => {
        updateInfo(data).then(res => {
          if (res.status == 200) {
            this.$emit('getInfo');
            this.$message('提交成功');
          } else {
            this.$message(res.message);
          }
          loading.close();
        })
      })
    },
    idCardViewSet() {
      if (this.idCardFlag) {
        this.idCardFlag = false;
      } else {
        this.idCardFlag = true;
      }
    },
    bankCardViewSet() {
      if (this.bankCardFlag) {
        this.bankCardFlag = false;
      } else {
        this.bankCardFlag = true;
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.status == 200) {
        this.headPic = res.data.url;
        this.headPicUrl = URL.createObjectURL(file.raw);
        this.$message("上传成功");
      } else {
        this.$message(res.message);
      }
    },
    //身份证正面
    handleAvatarSuccess1(res, file) {
      if (res.status == 200) {
        this.idCardFront = res.data.url;
        this.idCardFrontImage = URL.createObjectURL(file.raw);
        this.$message("上传成功");
      } else {
        this.$message(res.message);
      }
    },
    //身份证反面
    handleAvatarSuccess2(res, file) {
      if (res.status == 200) {
        this.idCardBack = res.data.url;
        this.idCardBackImage = URL.createObjectURL(file.raw);
        this.$message("上传成功");
      } else {
        this.$message(res.message);
      }
    },
    //银行卡正面
    handleAvatarSuccess3(res, file) {
      if (res.status == 200) {
        this.bankCardFront = res.data.url;
        this.bankCardFrontImage = URL.createObjectURL(file.raw);
        this.$message("上传成功");
      } else {
        this.$message(res.message);
      }
    },
    //银行卡反面
    handleAvatarSuccess4(res, file) {
      if (res.status == 200) {
        this.bankCardBack = res.data.url;
        this.bankCardBackImage = URL.createObjectURL(file.raw);
        this.$message("上传成功");
      } else {
        this.$message(res.message);
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    beforeAvatarUpload2(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isLt2M;
    },
  },
  data() {
    return {
      nickname: '',
      idCardName: '',
      tel: '',
      idCardNum: '',
      bankCardNum: '',
      bankCardName: '',
      headPic: '',
      idCardFront: '',
      idCardBack: '',
      bankCardFront: '',
      bankCardBack: '',

      idCardBackImage: '',
      idCardFrontImage: '',
      bankCardBackImage: '',
      bankCardFrontImage: '',
      headerPicUploadUrl: '',
      idCardFlag: false,
      bankCardFlag: false,
      imageUrl: '',
      name: '',
    };
  },
};
</script>

<style>
.personalData_page1 .el-table__empty-text {
  width: 280px;
}

.avatar-uploader .el-upload {
  background: #F3F4F9;
  border: 1px solid #E9EBED;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 88px;
  height: 88px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 10px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}

.avatar-uploader .avatar {
  width: 88px;
  height: 88px;
  display: block;
}

.avatar-uploader2 .el-upload {
  background: #F3F4F9;
  border: 1px solid #E9EBED;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 192px;
  height: 108px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 10px;
}

.avatar-uploader2 .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader2 .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}

.avatar-uploader2 .avatar {
  width: 192px;
  height: 108px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/spreader/personalData.vue